<template>
  <div class="paySuccessBox">
    <div class="paySuccess_main">
      <div class="paySuccess_mainTitle">
        <i
          class="el-icon-check"
          style="font-weight: 900; margin-right: 15px"
        ></i
        >支付成功！我们会尽快为您发货！
      </div>
      <div class="paySuccess_mainInfo">
        <span style="margin-bottom: 7px">订单号：249044124517</span>
        <span>在线支付：988.00元</span>
      </div>
      <div class="paySuccess_mainBtnBox">
        <div class="paySuccess_mainBtn">继续逛逛</div>
        <div class="paySuccess_mainBtn">查看订单详情</div>
      </div>
      <div class="paySuccess_mainTips">重要提示：</div>
      <div class="paySuccess_mainText">
        鲜丰汇平台及销售商不会以<span style="color: #84c049"
          >订单异常、系统升级</span
        >为由，要求您点击任何链接进行退款。
      </div>
    </div>
    <div class="paySuccess_title">个性推荐</div>
    <div class="main">
      <div class="mainList" v-for="(item, index) in 10" :key="index">
        <img src="" alt="" class="mainList_img" />
        <div class="mainList_body">
          <span class="mainList_text1"
            >来伊份盐焗凤爪108g 肉小吃休闲零 食休闲食品</span
          >
          <div class="mainList_price">
            <span class="mainList_text3"
              ><span style="font-size: 14px">￥</span>188.00</span
            ><span class="mainList_text4">￥188.00</span>
          </div>
          <div class="mainList_shopCar">
            <div class="mainList_shopCarL">
              <div class="mainList_shopCarNum">{{ numList[index] }}</div>
              <div class="mainList_btnBox">
                <button
                  class="mainList_shopCarAdd"
                  style="transform: rotate(180deg)"
                  @click="addNum(index)"
                >
                  <i class="iconfont">&#xe624;</i>
                </button>
                <button class="mainList_shopCarAdd" @click="reduceNum(index)">
                  <i class="iconfont">&#xe624;</i>
                </button>
              </div>
              <span class="unit">件</span>
            </div>
            <button class="mainList_shopCarBtn">加入购物车</button>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        layout=" prev, pager, next,total, jumper"
        :total="400"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      numList: [0],
      currentPage4: 4,
    };
  },
  methods: {
    // 页码大小发生变化
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    // 页码变化
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
    },
    addNum(index) {
      this.$set(this.numList, index, this.numList[index] + 1);
    },
    reduceNum(index) {
      if (this.numList[index] > 0) {
        this.$set(this.numList, index, this.numList[index] - 1);
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/paySuccess";
</style>



// WEBPACK FOOTER //
// src/components/page/paySuccess.vue